/**
 * Stable CSS class names for E2E — Criteria type grid (table + dialog + pagination).
 */
export const CTG = {
    root: 'criteria-type-grid',
    tablePaper: 'criteria-type-grid__table-paper',
    table: 'criteria-type-grid__table',
    head: 'criteria-type-grid__head',
    headRow: 'criteria-type-grid__head-row',
    headCell: 'criteria-type-grid__head-cell',

    body: 'criteria-type-grid__body',
    row: 'criteria-type-grid__row',
    cell: 'criteria-type-grid__cell',
    cellId: 'criteria-type-grid__cell--id',
    cellTenant: 'criteria-type-grid__cell--tenant',
    cellName: 'criteria-type-grid__cell--name',
    cellKey: 'criteria-type-grid__cell--key',
    cellValuesCount: 'criteria-type-grid__cell--values-count',
    cellActions: 'criteria-type-grid__cell--actions',

    valuesChip: 'criteria-type-grid-input--chip-values',
    editButton: 'criteria-type-grid-input--button-edit',
    deleteButton: 'criteria-type-grid-input--button-delete',
    editIcon: 'criteria-type-grid__edit-icon',
    deleteIcon: 'criteria-type-grid__delete-icon',

    pagination: 'criteria-type-grid__pagination',

    detailsDialog: 'criteria-type-grid__details-dialog',
    detailsDialogTitle: 'criteria-type-grid__details-dialog-title',
    detailsDialogTitleLayout: 'criteria-type-grid__details-dialog-title-layout',
    detailsDialogTitleName: 'criteria-type-grid__details-dialog-title-name',
    detailsDialogCloseButton: 'criteria-type-grid-input--button-dialog-close',
    detailsDialogCloseIcon: 'criteria-type-grid__details-dialog-close-icon',
    detailsDialogContent: 'criteria-type-grid__details-dialog-content',

    detailsTable: 'criteria-type-grid__details-table',
    detailsTableHead: 'criteria-type-grid__details-table-head',
    detailsTableHeadRow: 'criteria-type-grid__details-table-head-row',
    detailsTableHeadCell: 'criteria-type-grid__details-table-head-cell',
    detailsTableBody: 'criteria-type-grid__details-table-body',
    detailsTableRow: 'criteria-type-grid__details-table-row',
    detailsTableCell: 'criteria-type-grid__details-table-cell',
} as const;

export const ctgCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

